import { AIForMeTool } from "lib/models/aiforme-models";

import {
  AiForMeFormData,
  BasePlatform,
  BasePlatformMetadataTaxonomyId,
  DataClassification,
  PlatformName,
  SecurityReviewSystem,
  ToolMaturity,
  YesNo,
} from "../constants/platform-constants";
import { detectPlatform } from "./platform-detection-helper";

/**
 * Converts lowercase yes/no strings to YesNo enum values
 */
function normalizeYesNo(value: string | YesNo | undefined): YesNo | undefined {
  if (!value) return undefined;
  const lowerValue = value.toString().toLowerCase();
  if (lowerValue === "yes") return YesNo.YES;
  if (lowerValue === "no") return YesNo.NO;
  return value as YesNo;
}

/**
 * Casts an AiForMeTool to AiForMeFormData for form editing
 */
export function castToolToFormData(tool: AIForMeTool): AiForMeFormData {
  const directToolUrl = tool.directToolUrl || tool.learnMoreLink;
  const urlAnalysis = detectPlatform(directToolUrl);

  return {
    title: tool.title,
    description: tool.description,
    directToolUrl,
    documentationUrl: tool.documentationUrl || "",
    selectedCategories: tool.categories || [],
    selectedJobFamilies: tool.jobFamilies || [],
    toolMaturity: (tool.toolMaturity as ToolMaturity) || ToolMaturity.DEVELOPMENT,
    dataClassification: (tool.dataClassification as DataClassification) || DataClassification.PUBLIC,
    basePlatform: urlAnalysis?.basePlatform || (tool.basePlatform as BasePlatform) || BasePlatform.OTHER,
    platformName: urlAnalysis?.platformName || PlatformName.THIRD_PARTY,
    urlAnalysis,
    securityReviewed: normalizeYesNo(tool.securityReviewed),
    securityReviewLink: tool.securityReviewLink,
    securityReviewSystem: (tool.securityReviewSystem as SecurityReviewSystem) || undefined,
    modelsUsed: tool.modelsUsed,
    otherModel: tool.otherModel,
    storesInputPrompts: normalizeYesNo(tool.storesInputPrompts),
    collectsDataForRetraining: normalizeYesNo(tool.collectsDataForRetraining),
    username: tool.username,
    toolBindle: tool.toolBindle,
    toolCTILink: tool.toolCTILink,
    creationDate: tool.creationDate,
    taxonomyId: tool.taxonomyId,
    status: tool.status,
    tags: tool.tags,
    basePlatformMetadataTaxonomyId:
      urlAnalysis?.basePlatformMetadataTaxonomyId ||
      (tool.basePlatformMetadataTaxonomyId as BasePlatformMetadataTaxonomyId),
  };
}
